module.exports = __webpack_public_path__ + "static/media/Reji.7d8e5b8c.jpeg";